import script from "./AgentLanding.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentLanding.vue?vue&type=script&setup=true&lang=js"

import "./AgentLanding.vue?vue&type=style&index=0&id=1959560c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1959560c"]])

export default __exports__